import { useEffect, useState } from 'react';
import { homes as homesApi, type Home } from '../lib/api.js';
import { useAuth } from '../context/AuthContext.js';

export function HomeSwitcher() {
  const { currentHomeId, setCurrentHomeId, accessToken } = useAuth();
  const [homes, setHomes] = useState<Home[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!accessToken) return;
    homesApi
      .list()
      .then((r) => setHomes(r.homes))
      .catch(() => setHomes([]));
  }, [accessToken]);

  const current = homes.find((h) => h.id === currentHomeId) ?? homes[0];

  if (homes.length === 0) {
    return <span className="text-sm text-[var(--ac-text-muted)]">No homes</span>;
  }

  const onSelect = async (id: string) => {
    setCurrentHomeId(id);
    setOpen(false);
    try {
      await homesApi.switchHome(id);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="px-3 py-1.5 rounded-lg border text-sm flex items-center gap-2"
        style={{
          backgroundColor: 'var(--ac-surface-elevated)',
          borderColor: 'var(--ac-border)',
          color: 'var(--ac-text)',
        }}
      >
        <span>{current?.glyph ?? '🏠'}</span>
        <span>{current?.name ?? '—'}</span>
        <span className="text-[var(--ac-text-muted)]">▾</span>
      </button>
      {open ? (
        <div
          className="absolute left-0 mt-1 w-56 rounded-lg border shadow-lg z-40"
          style={{ backgroundColor: 'var(--ac-surface)', borderColor: 'var(--ac-border)' }}
        >
          {homes.map((h) => (
            <button
              key={h.id}
              type="button"
              onClick={() => void onSelect(h.id)}
              className="w-full text-left px-3 py-2 text-sm hover:bg-[var(--ac-surface-elevated)] flex items-center gap-2"
              style={{ color: 'var(--ac-text)' }}
            >
              <span>{h.glyph ?? '🏠'}</span>
              <span className="flex-1">{h.name}</span>
              {h.id === currentHomeId ? <span className="text-[var(--ac-accent)]">✓</span> : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
